{
  "featuredEvent": "Featured Event",
  "upcomingEvents": "Upcoming Events",
  "rsvp": "RSVP",
  "dateAtTime": "{{date}} at {{time}}",
  "dateRange": "{{start}} - {{end}}",
  "descriptionFrameTitle": "Event description",
  "notFoundTitle": "Event Not Found",
  "notFoundDescription": "We couldn't find that event."
}
